__turbopack_context__.v({
  "show_row": "ShowRow-module-scss-module__7l6pHG__show_row",
  "show_row__show_poster": "ShowRow-module-scss-module__7l6pHG__show_row__show_poster",
  "splide__slide": "ShowRow-module-scss-module__7l6pHG__splide__slide",
  "top_ten_item": "ShowRow-module-scss-module__7l6pHG__top_ten_item",
  "top_ten_item__count": "ShowRow-module-scss-module__7l6pHG__top_ten_item__count",
  "top_ten_item__poster_container": "ShowRow-module-scss-module__7l6pHG__top_ten_item__poster_container",
  "top_ten_show_row": "ShowRow-module-scss-module__7l6pHG__top_ten_show_row",
});
